import { useCallback, useRef, useState } from "react";

export const useFlashcardCardUIStateWeb = () => {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);

  const onToggleDescription = useCallback(() => {
    if (isDescriptionExpanded) {
      setIsDescriptionExpanded(false);
      scrollRef.current?.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    setIsDescriptionExpanded(true);
  }, [isDescriptionExpanded]);

  return {
    scrollRef,
    isDescriptionExpanded,
    onToggleDescription,
  };
};
